import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";

import ProfileDetailModal from "../../../common/ProfileDetailModal";
import {
  categorizeRecipients,
  findUser,
  showMemberProfile,
} from "../../../utils/helper";
import { getUserProfileDetails } from "../../../appStore/actions/AppState/action";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import {
  AccountLevelArkchatPermission,
  GroupLevelArkchatPermission,
  InviteType,
} from "../../../utils/constant";
import { useTranslation } from "react-i18next";
import { groupExternalMember } from "../../../utils/externalMemberGroping";
import useProgressiveList from "../../../customHooks/useProgressiveList";

import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
const classes = {
  drawerBody: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#183243",
    color: "#0000",
    padding: "0 0.3rem",
    minHeight: "38px",
  },
  iconDiv: crossIconDiv,
  iconn: { ...crossIcon, color: "#FFFFFF" },
  chatUserprofile: {
    bgcolor: "#E3E1E1",
    width: "30px",
    height: "30px",
    display: "flex",
    display: "-webkit-box",
    display: "-ms-flexbox",
    display: "-webkit-flex,",
    alignContent: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    WebkitBoxPack: "center",
    msFlexPack: "center",
    borderRadius: "0.15rem",
    fontWeight: "500",
    objectFit: "cover",
    img: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
      borderRadius: "3px",
    },
  },
};
const GrouMemberList = ({ handleCloseMemberDrawer }) => {
  const NameBadge = createStyledIndicatorButton("#E3E1E1");
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [profileViewData, setProfileViewData] = useState("");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [externalMemberData, setExternalMemberData] = useState([]);
  const dispatch = useDispatch();
  const { currentUserData, groupmemberdetails, groupRecipientDetails } =
    useAppSelectors();
  const { external: externalGroupRecipient } = categorizeRecipients(
    groupmemberdetails?.internalMember,
    groupRecipientDetails
  );
  const handleShowUserProfile = (userToFindData) => {
    showMemberProfile(
      findUser(groupmemberdetails, userToFindData),
      userToFindData,
      (userId) => dispatch(getUserProfileDetails(userId)),
      setProfileViewData,
      setProfileViewModal,
    );
  };
  useEffect(() => {
    if (externalGroupRecipient?.length > 0) {
      const groupedExternalData = groupExternalMember(
        externalGroupRecipient,
        true,
        appContent?.KEY34
      );

      setExternalMemberData(groupedExternalData);
    }
  }, []);
  // const handleShowUserProfile = (userToFindData) => {
  //   const data = findUser(groupmemberdetails, userToFindData);
  //   const viewData = {
  //     companyName: data?.userData?.subscriberFirmName,
  //     userName: `${data?.userInfo?.firstName} ${data?.userInfo?.lastName}`,
  //     industryName: data?.userData?.subscriberAccountIndustry,
  //     cityName: data?.userData?.city,
  //     countryName: data?.userData?.country,
  //     profileBrief: data?.userInfo?.profileBrief,
  //     profileImgUrl: data?.userInfo?.profileImgUrl,
  //     coverImgUrl: data?.userInfo?.coverImgUrl,
  //     isGroup: false,
  //     website: data?.userInfo?.website,
  //     linkedin: data?.userInfo?.linkedin,
  //   };
  //   setProfileViewData(viewData);
  //   setProfileViewModal(true);
  // };
  // A big group's members are built a part at a time as the list scrolls
  // (internal members, then external ones by company): building all 2,000
  // rows took over a second and a half.
  const internalMembers = groupmemberdetails?.internalMember || [];
  const externalRowCount = useMemo(
    () => externalMemberData.reduce((n, company) => n + (Object.values(company)[0]?.length || 0), 0),
    [externalMemberData],
  );
  const totalRows = internalMembers.length + externalRowCount;
  const [shownRows, listRef, moreRef] = useProgressiveList(totalRows);
  const visibleExternal = [];
  let externalBudget = shownRows - internalMembers.length;
  for (const company of externalMemberData) {
    if (externalBudget <= 0) break;
    const rows = (Object.values(company)[0] || []).slice(0, externalBudget);
    externalBudget -= rows.length;
    visibleExternal.push({ company, rows });
  }

  return (
    <React.Fragment>
      <ProfileDetailModal
        setProfileViewModal={setProfileViewModal}
        isProfileViewOpen={isProfileViewOpen}
        profileViewData={profileViewData}
        setProfileViewData={setProfileViewData}
      />
      <Box sx={classes.drawerBody}>
        <Stack sx={{ height: "100%" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ ...classes.header, flexShrink: 0 }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography sx={classes.iconDiv}>
                <CloseIcon
                  sx={classes.iconn}
                  onClick={handleCloseMemberDrawer}
                />
              </Typography>
              <Typography color={"#FFFFFF"} fontSize={"14px"} fontWeight={400}>
                Group Members
              </Typography>
            </Stack>
          </Stack>
          <React.Fragment>
            <Box
              ref={listRef}
              mt={"0.5rem"}
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overflowX: "hidden",
                "&::-webkit-scrollbar": {
                  width: "2px",
                  padding: "0px 2px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#183243",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "grey",
                },
              }}
            >
              {internalMembers.length > 0 &&
                internalMembers.slice(0, shownRows).map((memberData, i) => (
                  <Box key={memberData.userId + "recipientList"}>
                    {i === 0 && (
                      <>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={1}
                          padding="0px 19px 0px 12px"
                        >
                          <FormControlLabel
                            sx={{
                              cursor:"default",
                              ".MuiFormControlLabel-label": {
                                fontWeight: 600,
                                color: "#000000",
                              },
                            }}
                            control={
                              <Checkbox
                                checked={false}
                                sx={{
                                  cursor:"default",
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 30,
                                    color: "#183243",
                                    
                                  },
                                }}
                                icon={
                                  <NameBadge
                                    sx={{ color: "#183243" }}
                                    size="small"
                                    variant="contained"
                                  >
                                    <Typography
                                      color={"#183243"}
                                      fontSize={"0.75rem"}
                                      fontWeight={600}
                                    >
                                      {
                                        currentUserData?.activeSubscriber
                                          ?.subscriberFirmName[0]
                                      }
                                    </Typography>
                                  </NameBadge>
                                }
                              />
                            }
                            label={
                              <Typography
                                title={
                                  currentUserData?.activeSubscriber
                                    ?.subscriberFirmName
                                }
                                maxWidth={"25rem"}
                                overflow={"hidden"}
                                textOverflow={"ellipsis"}
                                whiteSpace={"nowrap"}
                                fontSize={"0.88rem"}
                                fontWeight={600}
                              >
                                My Team
                              </Typography>
                            }
                          />
                        </Stack>
                      </>
                    )}
                    {memberData?.permissionType !==
                      GroupLevelArkchatPermission?.REMOVE && (
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        padding={"0rem 0.7rem 0rem 2rem"}
                      >
                        <FormControlLabel
                          sx={{
                            ".MuiFormControlLabel-label": {
                              fontSize: "0.78rem !important",
                              color: "#000000",
                            },
                          }}
                          control={
                            <Checkbox
                              checked={false}
                              onClick={() =>
                                handleShowUserProfile(memberData?.userId)
                              }
                              onChange={(e) => e.preventDefault()}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 25,
                                  color: "#183243",
                                },
                              }}
                              icon={
                                <NameBadge
                                  sx={{
                                    width: "1.55rem",
                                    height: "1.55rem",
                                    color: "#183243",
                                    padding: memberData?.userInfo?.profileImgUrl
                                      ? "0rem"
                                      : "0.25rem 0.62rem",
                                    overflow: "hidden",
                                  }}
                                  size="small"
                                  variant="contained"
                                >
                                  {memberData?.userInfo?.profileImgUrl ? (
                                    <img
                                      style={{ width: "100%", height: "100%" }}
                                      src={memberData?.userInfo?.profileImgUrl}
                                      alt={memberData?.userInfo?.firstName}
                                    />
                                  ) : (
                                    <Typography
                                      color={"#183243"}
                                      fontSize={"0.75rem"}
                                    >
                                      {memberData?.userInfo?.firstName &&
                                        memberData?.userInfo?.firstName[0]}
                                    </Typography>
                                  )}
                                </NameBadge>
                              }
                            />
                          }
                          label={
                            <Box
                              display={"flex"}
                              alignItems={"center"}
                              gap={"0.15rem"}
                            >
                              <Typography
                                title={`${memberData?.userInfo?.firstName} ${memberData?.userInfo?.lastName}`}
                                maxWidth={"20rem"}
                                overflow={"hidden"}
                                textOverflow={"ellipsis"}
                                whiteSpace={"nowrap"}
                                fontSize={"0.78rem"}
                              >
                                {`${memberData?.userInfo?.firstName} ${memberData?.userInfo?.lastName}`}
                                <>,</>
                              </Typography>
                              {(() => {
                                if (
                                  memberData?.permission ===
                                    AccountLevelArkchatPermission?.ADMIN &&
                                  memberData?.inviteType ===
                                    InviteType?.ownerInviteType
                                ) {
                                  return (
                                    <Typography fontSize={"0.7rem"}>
                                      Owner
                                    </Typography>
                                  );
                                } else if (
                                  memberData?.permission ===
                                    AccountLevelArkchatPermission?.ADMIN &&
                                  memberData?.inviteType ===
                                    InviteType?.internal
                                ) {
                                  return (
                                    <Typography fontSize={"0.7rem"}>
                                      Admin
                                    </Typography>
                                  );
                                } else {
                                  return (
                                    <Typography fontSize={"0.7rem"}>
                                      User
                                    </Typography>
                                  );
                                }
                              })()}
                              {/* {!memberData?.membership && (
                                <Box
                                  ml="0.4rem"
                                  sx={{
                                    height: "0.5rem",
                                    width: "0.5rem",
                                    borderRadius: "50%",
                                    bgcolor: "red",
                                  }}
                                ></Box>
                              )} */}
                            </Box>
                          }
                        />
                      </Stack>
                    )}
                  </Box>
                ))}
              <Box>
                {visibleExternal.map(({ company, rows }, index) => (
                  <Box key={index + "externalRecipientGroup"}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={1}
                      padding="0px 19px 0px 12px"
                    >
                      <FormControlLabel
                        sx={{
                          cursor:"default",
                          ".MuiFormControlLabel-label": {
                            fontWeight: 600,
                            color: "#000000",
                          },
                        }}
                        control={
                          <Checkbox
                            checked={false}
                            sx={{
                              cursor:"default",
                              "& .MuiSvgIcon-root": {
                                fontSize: 30,
                                color: "#183243",
                              },
                            }}
                            icon={
                              <NameBadge
                                sx={{ color: "#183243" }}
                                size="small"
                                variant="contained"
                              >
                                <Typography
                                  color={"#183243"}
                                  fontSize={"0.75rem"}
                                  fontWeight={600}
                                >
                                  {Object.keys(company)[0] &&
                                    Object.keys(company)[0][0]}
                                </Typography>
                              </NameBadge>
                            }
                          />
                        }
                        label={
                          <Typography
                            title={Object.keys(company)[0]}
                            maxWidth={"25rem"}
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                            fontSize={"0.88rem"}
                            fontWeight={600}
                          >
                            {Object.keys(company)[0]}
                          </Typography>
                        }
                      />
                    </Stack>

                    {rows.map((item, i) => (
                      <Stack
                        key={i + "externalRecipientGroupCompany"}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        padding={"0rem 0.7rem 0rem 2rem"}
                      >
                        <FormControlLabel
                          sx={{
                            ".MuiFormControlLabel-label": {
                              fontSize: "0.78rem !important",
                              color: "#000000",
                            },
                          }}
                          control={
                            <Checkbox
                              onClick={() =>
                                handleShowUserProfile(item?.userId)
                              }
                              checked={false}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 25,
                                  color: "#183243",
                                },
                              }}
                              icon={
                                <NameBadge
                                  sx={{
                                    width: "1.55rem",
                                    height: "1.55rem",
                                    color: "#183243",
                                  }}
                                  size="small"
                                  variant="contained"
                                >
                                  <Typography
                                    color={"#183243"}
                                    fontSize={"0.75rem"}
                                  >
                                    {item?.firstName && item?.firstName[0]}
                                  </Typography>
                                </NameBadge>
                              }
                            />
                          }
                          label={
                            <Box
                              display={"flex"}
                              alignItems={"center"}
                              gap={"0.15rem"}
                            >
                              <Typography
                                title={`${item?.firstName} ${item?.lastName}`}
                                maxWidth={"20rem"}
                                overflow={"hidden"}
                                textOverflow={"ellipsis"}
                                whiteSpace={"nowrap"}
                                fontSize={"0.78rem"}
                              >
                                {`${item?.firstName} ${item?.lastName}`}
                                <>,</>
                              </Typography>
                              {(() => {
                                if (
                                  item?.accountPermission ===
                                  AccountLevelArkchatPermission?.ADMIN
                                ) {
                                  if (
                                    item?.inviteType ===
                                    InviteType?.ownerInviteType
                                  ) {
                                    return (
                                      <Typography fontSize={"0.7rem"}>
                                        Owner
                                      </Typography>
                                    );
                                  } else {
                                    return (
                                      <Typography fontSize={"0.7rem"}>
                                        Admin
                                      </Typography>
                                    );
                                  }
                                } else {
                                  return (
                                    <Typography fontSize={"0.7rem"}>
                                      User
                                    </Typography>
                                  );
                                }
                              })()}
                              {/* {!item?.membership && (
                                <Box
                                  ml="0.4rem"
                                  sx={{
                                    height: "0.5rem",
                                    width: "0.5rem",
                                    borderRadius: "50%",
                                    bgcolor: "red",
                                  }}
                                ></Box>
                              )} */}
                            </Box>
                          }
                        />
                      </Stack>
                    ))}
                  </Box>
                ))}
              </Box>
              {shownRows < totalRows && <Box ref={moreRef} height="1px" />}
            </Box>
            {/* <Box padding="12px">
              <Typography fontWeight={600}>Internal</Typography>
            </Box>
            {[...groupmemberdetails?.internalMember]?.map((item) => (
              <>
                {item?.permissionType !== 4 && (
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    padding="12px"
                    key={item?.userInfo?.id + "grpmemberdetails"}
                  >
                    {item?.userInfo?.profileImgUrl ? (
                      <Box
                        onClick={() => handleShowUserProfile(item?.userId)}
                        sx={{ ...classes.chatUserprofile, cursor: "pointer" }}
                      >
                        <img
                          src={item?.userInfo?.profileImgUrl}
                          alt="profile"
                          width={"100%"}
                          height="100%"
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleShowUserProfile(item?.userId)}
                        bgcolor={"#E3E1E1"}
                        width={"30px"}
                        height={"30px"}
                        display={"flex"}
                        flex={"none"}
                        alignItems={"center"}
                        flex-wrap={"wrap"}
                        justifyContent={"center"}
                        borderRadius={"0.15rem"}
                        // border={"1px solid blue"}
                      >
                        <Typography variant="h6" fontSize={"0.75rem"}>
                          {item?.userInfo?.firstName[0]}
                        </Typography>
                      </Box>
                    )}
                    <Typography>
                      {item?.userInfo?.firstName} {item?.userInfo?.lastName}
                    </Typography>
                  </Stack>
                )}
              </>
            ))}

            <Box padding="12px">
              <Typography fontWeight={600}>External</Typography>
            </Box>
            {[...externalGroupRecipient]?.map((item) => (
              <>
               <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    padding="12px"
                    key={item?.id + "grpmemberdetails"}
                  >
                    {item?.profileImgUrl ? (
                      <Box
                        onClick={() => handleShowUserProfile(item?.userId)}
                        sx={{ ...classes.chatUserprofile, cursor: "pointer" }}
                      >
                        <img
                          src={item?.profileImgUrl}
                          alt="profile"
                          width={"100%"}
                          height="100%"
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleShowUserProfile(item?.userId)}
                        bgcolor={"#E3E1E1"}
                        width={"30px"}
                        height={"30px"}
                        display={"flex"}
                        flex={"none"}
                        alignItems={"center"}
                        flex-wrap={"wrap"}
                        justifyContent={"center"}
                        borderRadius={"0.15rem"}
                        // border={"1px solid blue"}
                      >
                        <Typography variant="h6" fontSize={"0.75rem"}>
                          {item?.firstName[0]}
                        </Typography>
                      </Box>
                    )}
                    <Typography>
                      {item?.firstName} {item?.lastName}
                    </Typography>
                  </Stack>
              </>
            ))} */}
          </React.Fragment>
        </Stack>
      </Box>
    </React.Fragment>
  );
};

export default GrouMemberList;
